<template>
  <div class="top-menu">
    <el-menu :default-active="activeIndex" mode="horizontal" text-color="#333">
      <!-- <template v-for="(item,index) in items">
        <el-menu-item :index="item.parentId+''"
                      @click.native="openMenu(item)"
                      :key="index">
          <template slot="title">
            <i :class="item.icon"></i>
            <span>{{generateTitle(item)}}</span>
          </template>
        </el-menu-item>
      </template> -->

      <!-- 应用项目 -->
      <el-menu-item>
        <div class="menuTitle">
          <span>应用项目：</span>
          <el-select
            v-model="$store.state.httpRules.projectIdValue"
            size="mini"
            placeholder="请选择项目"
          >
            <el-option
              v-for="(item, index) of $store.state.httpRules.projectData"
              :key="index"
              :label="item.projectName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "top-menu",
  data() {
    return {
      projectIdValue: this.$store.state.httpRules.projectIdValue,
      activeIndex: "0",
      items: [],
    };
  },
  created() {
    // this.getMenu();
    // 请求项目
    this.$store.dispatch("getProjectData");
  },
  computed: {
    ...mapGetters(["tagCurrent", "menu"]),
  },
  methods: {
    getMenu() {
      this.$store.dispatch("GetTopMenu").then((res) => {
        this.items = res;
      });
    },
    generateTitle(item) {
      return this.$router.$avueRouter.generateTitle(
        item.label,
        (item.meta || {}).i18n
      );
    },
    openMenu(item) {
      this.$store.dispatch("GetMenu", item.parentId).then((data) => {
        if (data.length !== 0) {
          this.$router.$avueRouter.formatRoutes(data, true);
        }
        let itemActive,
          childItemActive = 0;
        if (item.path) {
          itemActive = item;
        } else {
          if (this.menu[childItemActive].length == 0) {
            itemActive = this.menu[childItemActive];
          } else {
            itemActive = this.menu[childItemActive].children[childItemActive];
          }
        }
        this.$router.push({
          path: this.$router.$avueRouter.getPath({
            name: itemActive.label,
            src: itemActive.path,
            i18n: itemActive.meta.i18n,
          }),
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.menuTitle {
  display: flex;
  align-items: center;
  > span {
    color: #606266;
    font-size: 14px;
  }
}
</style>
